import {
  AddIcon,
  BellIcon,
  EditIcon,
  InfoIcon,
} from '@chakra-ui/icons';
import {
  Badge,
  Box,
  Button,
  Flex,
  Text,
  Tooltip,
  VStack,
} from '@chakra-ui/react';

interface HandleCellClickFunction {
  (
    row: string,
    column: string,
    value: string | null,
    uuid: string | null,
    expirationDate?: string | null
  ): void;
}
interface SubCardProps {
  bodyText?: string;
  expiration?: string;
  type: 'daily alert' | 'office notes:';
  uuid: string | null;
  keyValue: string;
  handleCellClick: HandleCellClickFunction;
}
export const SubCard: React.FC<SubCardProps> = ({
  bodyText,
  expiration,
  type,
  uuid,
  keyValue,
  handleCellClick,
}) => {
  return (
    <Box borderWidth="1px" borderRadius="xl" boxShadow="inner" p={4}>
      <VStack align="stretch" spacing={1}>
        <Flex align="center">
          {type === 'daily alert' ? (
            <BellIcon mr={2} color={'blue.600'} />
          ) : (
            <InfoIcon mr={2} color={'blue.600'} />
          )}
          <Text fontWeight="semibold" color={'blue.600'}>
            {type === 'daily alert' ? 'Daily Alerts' : 'Office Notes'}
          </Text>
        </Flex>
        {bodyText ? (
          <Flex
            alignItems={'center'}
            justifyContent={'space-between'}
          >
            <Tooltip label={bodyText}>
              <Text isTruncated>{bodyText}</Text>
            </Tooltip>
            <Tooltip
              label={
                type === 'daily alert'
                  ? 'Edit Daily Alerts'
                  : 'Edit Office Notes'
              }
            >
              <Button
                variant={'ghost'}
                onClick={() => {
                  handleCellClick(
                    keyValue,
                    type,
                    bodyText,
                    uuid,
                    expiration
                  );
                }}
              >
                <EditIcon color={'blue.500'} />
              </Button>
            </Tooltip>
          </Flex>
        ) : (
          <Button
            mb={1}
            leftIcon={<AddIcon />}
            onClick={() => {
              handleCellClick(
                keyValue,
                type,
                '',
                uuid,
                expiration
              );
            }}
          >
            Add
          </Button>
        )}
      </VStack>
      {expiration && (
        <Badge
          colorScheme={'blue'}
        >{`Expires On: ${expiration}`}</Badge>
      )}
    </Box>
  );
};
